// src/pages/FeedbackPage.js
import React, { useState } from 'react';
import '../styles/FeedbackPage.css';
import { sendFeedback } from '../utils/api';

const FeedbackPage = () => {
  const [email, setEmail] = useState('');
  const [business, setBusiness] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // 'ok' | 'err' | null

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !message) {
      setStatus('err');
      return;
    }
    if (message.trim().length < 5) {
      setStatus('Please enter at least 5 characters.');
      return;
    }

    setSubmitting(true);
    setStatus(null);
    try {
      await sendFeedback({ email, business_name: business || null, message });
      setStatus('ok');
      setEmail('');
      setBusiness('');
      setMessage('');
    } catch (err) {
      // Show backend detail if available (e.g., SMTP auth failures)
      const msg = err?.message || 'err';
      setStatus(msg);
    } finally {
      setSubmitting(false);
    }

  };

  return (
    <main className="feedback-container">
      <h1 className="feedback-title">Feedback</h1>
      <p className="feedback-subtitle">

        Tell us what’s working and what’s not. We read everything.
      </p>

      <form onSubmit={onSubmit} className="feedback-card">
        <div className="form-row">

          <label htmlFor="fb-email" className="form-label">Email<span style={{ color: '#ef4444' }}> *</span></label>
          <input
            id="fb-email"
            type="email"
            className="input"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div className="form-row">

          <label htmlFor="fb-biz" className="form-label">Business name (optional)</label>
          <input
            id="fb-biz"
            type="text"
            className="input"
            placeholder="Acme Inc."
            value={business}
            onChange={(e) => setBusiness(e.target.value)}
          />
        </div>

        <div className="form-row">

          <label htmlFor="fb-msg" className="form-label">Feedback<span style={{ color: '#ef4444' }}> *</span></label>
          <textarea
            id="fb-msg"
            className="textarea"
            placeholder="Share your thoughts…"
            rows={6}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>

        <div className="feedback-actions">
          <button
            type="submit"
            className="btn-navy"
            disabled={submitting}
            aria-busy={submitting ? 'true' : 'false'}
          >
            {submitting ? 'Sending…' : 'Send feedback'}
          </button>

          {status === 'ok' && (
            <span role="status" className="feedback-success">
              Thanks—your feedback was sent.
            </span>
          )}
          {status && status !== 'ok' && (
            <span role="alert" className="feedback-error">
              {String(status).startsWith('HTTP') || String(status).includes('SMTP') || String(status).includes('auth')
                ? String(status)
                : "Couldn’t send. Please check your email and message, then try again."}
            </span>
          )}

        </div>
      </form>

      <p className="feedback-footnote">
        Your message is sent to our team at contact@getclairifi.com.
      </p>
    </main>
  );
};

export default FeedbackPage;
